import { AttachedMacroCard, EmptyContent, MacroWrap } from '@shared/components/core/listing/CommonListingStyles';
import { MacroDisplayModel } from '@shared/models/deviceProfiles/MacroModel';
import { useTranslation } from 'react-i18next';
import MacroExpanderCard from './MacroExpanderCard';

export interface IMacroListingProps {
    macros: MacroDisplayModel[] | null;
    startExpanded?: boolean;
}

function MacroListing({ macros, startExpanded = false }: IMacroListingProps) {
    const { t } = useTranslation();
    return macros && macros.length > 0 ? (
        <MacroWrap>
            {macros.map((macro, i) => (
                <MacroExpanderCard key={`macro_${i}`} macro={macro} startExpanded={startExpanded} id={macro.id}>
                    <AttachedMacroCard macro={macro} showTitle={false} />
                </MacroExpanderCard>
            ))}
        </MacroWrap>
    ) : (
        <EmptyContent>{t('common:macroEmpty')}</EmptyContent>
    );
}

export default MacroListing;
